import { render, staticRenderFns } from "./InstructorRegistration.vue?vue&type=template&id=1bf00291&scoped=true"
import script from "./InstructorRegistration.vue?vue&type=script&lang=js"
export * from "./InstructorRegistration.vue?vue&type=script&lang=js"
import style0 from "./InstructorRegistration.vue?vue&type=style&index=0&id=1bf00291&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf00291",
  null
  
)

export default component.exports